import React, { useLayoutEffect, useRef, useState, type ReactNode } from 'react';

/** The Snak is authored for a standard 390px-wide phone viewport. */
const DESIGN_WIDTH = 390;

/**
 * Renders its children at the Snak's native phone width and scales the whole viewport
 * to fit the device frame, so layouts never squeeze or overflow inside a smaller preview.
 * The scaled layer also acts as the containing block for the Snak's fixed sheets.
 */
export function PhoneViewport({
  children
}: {
  children: ReactNode;
}) {
  const hostRef = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<{
    w: number;
    h: number;
  } | null>(null);
  useLayoutEffect(() => {
    const el = hostRef.current;
    if (!el) return;
    const measure = () => setSize({
      w: el.clientWidth,
      h: el.clientHeight
    });
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  const scale = size ? size.w / DESIGN_WIDTH : 1;
  const innerHeight = size ? size.h / scale : 0;
  return <div ref={hostRef} className="phone-screen relative flex-1 overflow-hidden" data-id="element-7" data-mp="20tjnubtntty8">
      {size && <div className="absolute left-0 top-0 origin-top-left" style={{
      width: DESIGN_WIDTH,
      height: innerHeight,
      transform: `scale(${scale})`
    }} data-id="element-8" data-mp="24v59alk9fgk1">
          {children}
        </div>}
    </div>;
}